module.exports = __webpack_public_path__ + "static/media/1.bc42d46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/chat/1.png
// module id = 115
// module chunks = 0